import axios from "axios";
import Cookies from "js-cookie";
import { urlServeur } from "./env";

const api_base = `${urlServeur}/api/`;

const Api = axios.create({
  baseURL: api_base,
});

const Api_Token = axios.create({
  baseURL: api_base,
  // headers: {
  //    'Content-Type': 'application/json',
  //  }
});

function updateAuthToken(token) {
  Api_Token.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

const authToken = Cookies.get("token");
if (authToken !== undefined) {
  updateAuthToken(authToken);
}
export { api_base, updateAuthToken, Api_Token, Api };
